import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const RubyIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <defs>
        <linearGradient
          x1="84.7503645%"
          y1="111.305976%"
          x2="58.2543962%"
          y2="64.5615295%"
          id="linearGradient-1"
        >
          <stop stopColor="#FB7655" offset="0%" />
          <stop stopColor="#FB7655" offset="0%" />
          <stop stopColor="#E42B1E" offset="41%" />
          <stop stopColor="#990000" offset="99%" />
          <stop stopColor="#990000" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="69.4018185%"
          y1="60.8903211%"
          x2="35.9535206%"
          y2="19.2879503%"
          id="linearGradient-2"
        >
          <stop stopColor="#871101" offset="0%" />
          <stop stopColor="#871101" offset="0%" />
          <stop stopColor="#911209" offset="99%" />
          <stop stopColor="#911209" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="75.7744024%"
          y1="52.3080468%"
          x2="38.9781357%"
          y2="49.4251755%"
          id="linearGradient-3"
        >
          <stop stopColor="#871101" offset="0%" />
          <stop stopColor="#871101" offset="0%" />
          <stop stopColor="#911209" offset="99%" />
          <stop stopColor="#911209" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50.0056073%"
          y1="7.23449921%"
          x2="57.4368579%"
          y2="79.1354134%"
          id="linearGradient-4"
        >
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#E57252" offset="23%" />
          <stop stopColor="#DE3B20" offset="46%" />
          <stop stopColor="#A60003" offset="99%" />
          <stop stopColor="#A60003" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="46.2812241%"
          y1="16.347907%"
          x2="49.9342275%"
          y2="83.0468449%"
          id="linearGradient-5"
        >
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#E4714E" offset="23%" />
          <stop stopColor="#BE1A0D" offset="56%" />
          <stop stopColor="#A80D00" offset="99%" />
          <stop stopColor="#A80D00" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="36.9653573%"
          y1="32.9392556%"
          x2="49.5282324%"
          y2="71.0629719%"
          id="linearGradient-6"
        >
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#E46342" offset="18%" />
          <stop stopColor="#C82410" offset="40%" />
          <stop stopColor="#A80D00" offset="99%" />
          <stop stopColor="#A80D00" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="13.6086166%"
          y1="50.9841077%"
          x2="85.7636612%"
          y2="38.5953369%"
          id="linearGradient-7"
        >
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#C81F11" offset="54%" />
          <stop stopColor="#BF0905" offset="99%" />
          <stop stopColor="#BF0905" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="48.5990351%"
          y1="21.1345847%"
          x2="50.0466146%"
          y2="79.0557818%"
          id="linearGradient-8"
        >
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#FFFFFF" offset="0%" />
          <stop stopColor="#DE4024" offset="31%" />
          <stop stopColor="#BF190B" offset="99%" />
          <stop stopColor="#BF190B" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="-20.6671297%"
          y1="122.076363%"
          x2="104.241521%"
          y2="-6.18190104%"
          id="linearGradient-9"
        >
          <stop stopColor="#BD0012" offset="0%" />
          <stop stopColor="#BD0012" offset="0%" />
          <stop stopColor="#FFFFFF" offset="7%" />
          <stop stopColor="#FFFFFF" offset="17%" />
          <stop stopColor="#C82F1C" offset="27%" />
          <stop stopColor="#820C01" offset="33%" />
          <stop stopColor="#A31601" offset="46%" />
          <stop stopColor="#B31301" offset="72%" />
          <stop stopColor="#E82609" offset="99%" />
          <stop stopColor="#E82609" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="58.7919609%"
          y1="58.9344662%"
          x2="11.9636556%"
          y2="50.0749557%"
          id="linearGradient-10"
        >
          <stop stopColor="#8C0C01" offset="0%" />
          <stop stopColor="#8C0C01" offset="0%" />
          <stop stopColor="#990C00" offset="54%" />
          <stop stopColor="#A80D0E" offset="99%" />
          <stop stopColor="#A80D0E" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="73.2359851%"
          y1="62.7538068%"
          x2="28.6722026%"
          y2="17.8876818%"
          id="linearGradient-11"
        >
          <stop stopColor="#7E110B" offset="0%" />
          <stop stopColor="#7E110B" offset="0%" />
          <stop stopColor="#9E0C00" offset="99%" />
          <stop stopColor="#9E0C00" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="90.7171132%"
          y1="74.1223655%"
          x2="59.3450402%"
          y2="39.7039965%"
          id="linearGradient-12"
        >
          <stop stopColor="#79130D" offset="0%" />
          <stop stopColor="#79130D" offset="0%" />
          <stop stopColor="#9E120B" offset="99%" />
          <stop stopColor="#9E120B" offset="100%" />
        </linearGradient>
        <radialGradient
          cx="32.0008013%"
          cy="40.2100469%"
          fx="32.0008013%"
          fy="40.2100469%"
          r="133.144069%"
          gradientTransform="translate(0.320008,0.402100),scale(0.522539,1.000000),translate(-0.320008,-0.402100)"
          id="radialGradient-13"
        >
          <stop stopColor="#A80D00" offset="0%" />
          <stop stopColor="#A80D00" offset="0%" />
          <stop stopColor="#7E0E08" offset="99%" />
          <stop stopColor="#7E0E08" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="13.5493795%"
          cy="40.859922%"
          fx="13.5493795%"
          fy="40.859922%"
          r="113.54088%"
          gradientTransform="translate(0.135494,0.408599),scale(0.778453,1.000000),translate(-0.135494,-0.408599)"
          id="radialGradient-14"
        >
          <stop stopColor="#A30C00" offset="0%" />
          <stop stopColor="#A30C00" offset="0%" />
          <stop stopColor="#800E08" offset="99%" />
          <stop stopColor="#800E08" offset="100%" />
        </radialGradient>
        <linearGradient
          x1="51.6075293%"
          y1="101.716594%"
          x2="38.5261566%"
          y2="11.9932603%"
          id="linearGradient-15"
        >
          <stop stopColor="#8B2114" offset="0%" />
          <stop stopColor="#8B2114" offset="0%" />
          <stop stopColor="#9E100A" offset="43%" />
          <stop stopColor="#B3100C" offset="99%" />
          <stop stopColor="#B3100C" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="30.8698732%"
          y1="47.4871219%"
          x2="92.4707626%"
          y2="58.8456816%"
          id="linearGradient-16"
        >
          <stop stopColor="#B31000" offset="0%" />
          <stop stopColor="#B31000" offset="0%" />
          <stop stopColor="#910F08" offset="44%" />
          <stop stopColor="#791C12" offset="99%" />
          <stop stopColor="#791C12" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="Language-/-Ruby"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="ruby" transform="translate(3.000000, 3.000000)">
          <polygon
            id="polygon3282"
            fill="url(#linearGradient-1)"
            points="20.0552764 17.0384925 5.27577889 25.8144724 24.4124322 24.5159095 25.8863317 5.21959799"
          />
          <polygon
            id="polygon3293"
            fill="url(#linearGradient-2)"
            points="24.4437889 24.5027136 22.798995 13.1502513 18.3187638 19.0662312"
          />
          <polygon
            id="polygon3304"
            fill="url(#linearGradient-3)"
            points="24.466 24.5027136 12.4159799 23.5567839 5.33979899 25.7897789"
          />
          <polygon
            id="polygon3319"
            fill="url(#linearGradient-4)"
            points="5.35678392 25.7922613 8.36703518 15.9305528 1.74291457 17.3469648"
          />
          <polygon
            id="polygon3334"
            fill="url(#linearGradient-5)"
            points="18.3175879 19.0988945 15.5477387 8.24944724 7.62100503 15.6796985"
          />
          <polygon
            id="polygon3349"
            fill="url(#linearGradient-6)"
            points="25.2578894 8.40231156 17.7649246 2.28251256 15.678392 9.0281407"
          />
          <polygon
            id="polygon3362"
            fill="url(#linearGradient-7)"
            points="21.7537688 0.100603015 17.3468342 2.5359799 14.5665327 0.0679396985"
          />
          <polygon
            id="polygon3375"
            fill="url(#linearGradient-8)"
            points="0 20.6549749 1.84613065 17.2880402 0.352763819 13.2769849"
          />
          <path
            d="M0.253467337,13.1502513 L1.7559799,17.4121608 L8.28472362,15.947407 L15.7384925,9.02017085 L17.8420101,2.33869347 L14.5298191,0 L8.89866332,2.10743719 C7.12452261,3.75758794 3.68180905,7.02261307 3.55768844,7.0840201 C3.43487437,7.14673367 1.28432161,11.2113568 0.253467337,13.1502513 Z"
            id="path3377"
            fill="#FFFFFF"
          />
          <path
            d="M5.52924623,5.49396985 C9.37437186,1.68150754 14.3313568,-0.570954774 16.2336683,1.34834171 C18.134804,3.26763819 16.1186935,7.9319598 12.2735678,11.7431156 C8.42844221,15.5542714 3.53286432,17.9308543 1.6318593,16.0115578 C-0.270452261,14.0935678 1.6841206,9.30512563 5.52924623,5.49396985 Z"
            id="path3400"
            fill="url(#linearGradient-9)"
          />
          <path
            d="M5.35678392,25.7883417 L8.34351759,15.8952764 L18.2627136,19.0819095 C14.6762814,22.4449246 10.6874372,25.2879397 5.35678392,25.7883417 Z"
            id="path3413"
            fill="url(#linearGradient-10)"
          />
          <path
            d="M15.7515578,9.00070352 L18.2979899,19.0871357 C21.2938693,15.9370854 23.9827136,12.5505528 25.2995678,8.36180905 L15.7515578,9.00070352 Z"
            id="path3424"
            fill="url(#linearGradient-11)"
          />
          <path
            d="M25.2735678,8.41276382 C26.2926633,5.33718593 26.5278392,0.925025126 21.7222814,0.105829146 L17.7791658,2.2838191 L25.2735678,8.41276382 L25.2735678,8.41276382 Z"
            id="path3435"
            fill="url(#linearGradient-12)"
          />
          <path
            d="M0,20.6105528 C0.141105528,25.6865628 3.80331658,25.7622111 5.36331658,25.8067638 L1.7598995,17.3912563 L0,20.6105528 Z"
            id="path3437"
            fill="#9E1209"
          />
          <path
            d="M15.765799,9.01638191 C18.0679095,10.4313568 22.7075377,13.2730653 22.801608,13.3253266 C22.947809,13.4076382 24.8019095,10.198794 25.2226131,8.38532663 L15.765799,9.01638191 Z"
            id="path3448"
            fill="url(#radialGradient-13)"
          />
          <path
            d="M8.33959799,15.8952764 L12.3323618,23.598593 C14.6932663,22.318191 16.5420101,20.758191 18.2352764,19.0871357 L8.33959799,15.8952764 Z"
            id="path3459"
            fill="url(#radialGradient-14)"
          />
          <path
            d="M1.74422111,17.4017085 L1.17849246,24.138191 C2.24592965,25.5962814 3.71447236,25.7230151 5.25487437,25.6093467 C4.14040201,22.8355779 1.91407035,17.2893467 1.74422111,17.4017085 Z"
            id="path3472"
            fill="url(#linearGradient-15)"
          />
          <path
            d="M17.7557789,2.30080402 L25.6877387,3.41396985 C25.2644221,1.6201005 23.9644221,0.462512563 21.7485427,0.100603015 L17.7557789,2.30080402 Z"
            id="path3485"
            fill="url(#linearGradient-16)"
          />
        </g>
      </g>
    </SVG>
  );
};

export default RubyIcon;
